/**
 * Field name mappings between camelCase (React Flow) and snake_case (Legacy)
 */

/**
 * Field name mappings: camelCase → snake_case
 */
export const FIELD_NAME_MAPPINGS: Record<string, string> = {
  // Common IDs
  extensionId: 'extension_id',
  lineId: 'line_id',
  queueId: 'queue_id',
  soundClipId: 'sound_clip_id',
  soundClipUuid: 'sound_clip_uuid',
  faxExtensionId: 'fax_extension_id',
  scheduleId: 'schedule_id',
  scheduleUuid: 'schedule_uuid',
  transferRolloverId: 'transfer_rollover_id',
  conferenceRoomId: 'conference_room_id',
  dialPlanId: 'dial_plan_id',
  phoneNumberId: 'phone_number_id',
  transferCompany: 'transfer_company',
  newCallerId: 'new_caller_id',
  newCallerIdOption: 'new_caller_id_option',
  webhookId: 'webhook_id',
  notifyUrl: 'notify_url',
  iwebhookUrl: 'iwebhook_url',
  iwebhookAllowExtensionDialing: 'iwebhook_allow_extension_dialing',
  allowExtensionDialing: 'allow_extension_dialing',
  repeatTimes: 'repeat_times',
  ringDuringWait: 'ring_during_wait',
  passThroughCallerId: 'pass_through_caller_id',
  autoReplyToCaller: 'auto_reply',
  smsRecipient: 'sms_recipient',
  smsNumber: 'sms_number',
  lookupId: 'lookup_id',
  sortOrder: 'sort_order',
  directoryExtensionId: 'directory_extension_id',
  choiceId: 'choice_id',
  hangUpId: 'hang_up_id',
  targetSwitchboardId: 'dial_plan_id',
  agentId: 'agent_id',
  messageType: 'option', // Special: maps to 'option' for SMS
} as const

/**
 * Reverse field name mappings: snake_case → camelCase
 */
export const REVERSE_FIELD_NAME_MAPPINGS: Record<string, string> = {
  extension_id: 'extensionId',
  line_id: 'extensionId', // direct_line uses line_id but maps to extensionId
  queue_id: 'queueId',
  sound_clip_id: 'soundClipId',
  sound_clip_uuid: 'soundClipUuid',
  fax_extension_id: 'faxExtensionId',
  schedule_id: 'scheduleId',
  schedule_uuid: 'scheduleUuid',
  transfer_rollover_id: 'transferRolloverId',
  conference_room_id: 'conferenceRoomId',
  dial_plan_id: 'targetSwitchboardId',
  phone_number_id: 'phoneNumberId',
  transfer_company: 'transferCompany',
  new_caller_id: 'newCallerId',
  new_caller_id_option: 'newCallerIdOption',
  webhook_id: 'webhookId',
  notify_url: 'url',
  iwebhook_url: 'url',
  iwebhook_allow_extension_dialing: 'allowExtensionAsOption',
  allow_extension_dialing: 'allowExtensionDialing',
  repeat_times: 'repeatTimes',
  ring_during_wait: 'ringDuringWait',
  pass_through_caller_id: 'passThroughCallerId',
  auto_reply: 'autoReplyToCaller',
  sms_recipient: 'phoneNumber',
  sms_number: 'sendFrom',
  lookup_id: 'lookupId',
  sort_order: 'sortOrder',
  directory_extension_id: 'directoryExtensionId',
  choice_id: 'choiceId',
  hang_up_id: 'hangUpId',
  agent_id: 'agentId',
  option: 'messageType', // Special: maps to 'messageType' for SMS
} as const
